import React, { Fragment } from 'react';

export const rsvpInfoBlock = (
  <Fragment>
    <h4 className="page-ihfo-block__title">How It Works</h4>
    <div className="page-ihfo-block__content">
      <ul className="page-ihfo-block__list">
        <li>1. Add events and turn on online RSVP for any.</li>
        <li>2. Build your guest list to manage who’s invited to each event.</li>
        <li>3. When ready, make this page visible to guests.</li>
        <li>4. They’ll visit this page to fill out a personal RSVP form.</li>
        <li>5. We’ll record everyone’s responses in your guest list.</li>
      </ul>
    </div>
  </Fragment>
);



// WEBPACK FOOTER //
// ./src/constants/EditPagesContent/EditPagesInfoBlock.jsx